import React from 'react';

const Footer = () => {
    const style = {
        textAlign: 'center',
    };
    return (
        <div>
            <p style={style}>@copyright ama-jhone 2020.</p>
        </div>
    );
};

export default Footer;